import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { collection, query, where, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const CreateLoanApplicationModal = ({ isOpen, onClose, onSuccess, lenderMatchData }) => {
  useEffect(() => {
    if (!lenderMatchData?.id) {
      console.error('No lender match ID provided:', lenderMatchData);
      onClose();
    }
  }, [lenderMatchData, onClose]);

  const [formData, setFormData] = useState({
    creditScore: '',
    numberOfEmployees: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!lenderMatchData?.id) {
      alert('Error: No lender match ID found');
      return;
    }

    try {
      console.log('Searching for loan application with lenderMatchId:', lenderMatchData.id);
      
      const q = query(
        collection(db, 'loanApplications'), 
        where('lenderMatchId', '==', lenderMatchData.id)
      );
      
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const loanAppDoc = querySnapshot.docs[0];
        console.log('Found loan application:', loanAppDoc.id);
        
        await updateDoc(loanAppDoc.ref, {
          creditScores: [formData.creditScore],
          numberOfEmployees: formData.numberOfEmployees,
          lastUpdated: new Date()
        });

        onSuccess();
        onClose();
      } else {
        console.error('No loan application found for lenderMatchId:', lenderMatchData.id);
        throw new Error('No matching loan application found');
      }
    } catch (error) {
      console.error('Error updating loan application:', error);
      alert('Error updating loan application. Please try again.');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Create Loan Application</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Credit Score</label>
            <input
              type="text"
              name="creditScore"
              value={formData.creditScore}
              onChange={handleChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Number of Employees</label>
            <input
              type="text"
              name="numberOfEmployees"
              value={formData.numberOfEmployees}
              onChange={handleChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            />
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Create Application
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateLoanApplicationModal;